module.exports = __webpack_public_path__ + "static/media/3.82f39187.jpg";